export default __webpack_public_path__ + "static/media/img5.85afd31a.jpeg";